import { useState, useEffect } from "react";
import Sidebar from "../components/Sidebar";
import Notification from "../components/Notification";
import Header from "../components/Header";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faWallet, faMagnifyingGlass } from "@fortawesome/free-solid-svg-icons";
import { Link } from "react-router-dom";
import { useUser } from "../utils/UserContext";


import PortfolioCard from "../components/PortfolioCard";
import MarketStats from "../components/MarketStats";
import BitcoinMarketStats from '../components/BitcoinMarketStats';
import TradeForm from "../components/TradeForm";

import CoinsPortfolio from "../components/CoinsPortfolio";
import InvestmentPortfolio from "../components/InvestmentPortfolio";
import StockDashboard from "../components/StockDashboard";
import { useLocation } from "react-router-dom";
import TradingViewWidget from "../components/TradingViewWidget";

import {
  formatCurrency,
  getCurrencySymbol,
  getRate,
} from "../utils/currencyUtils";
import { toast } from "react-hot-toast";
import {
  faEye,
  faEyeSlash,
  faFileLines,
} from "@fortawesome/free-regular-svg-icons";

function Components() {


const location = useLocation();
const queryParams = new URLSearchParams(location.search);
const symbol = queryParams.get("symbol");
const tradetype = queryParams.get("tradetype");
const [openTrades, setOpenTrades] = useState([]);
const [closedTrades, setClosedTrades] = useState([]);
const [type, setType] = useState(tradetype ? tradetype : "crypto");
const [trade, setTrade] = useState(
symbol
? symbol
: type === "crypto"
? "BTC"
: type === "forex"
? "AAPL"
: "EUR"
);
  const [see, setSee] = useState(true);
  const { user } = useUser();
  const [stock, setStock] = useState([]);
  const [searchTerm, setSearchTerm] = useState("");
  const [isSidebarOpen, setIsSidebarOpen] = useState(false);
  const toggleSidebar = () => {
    setIsSidebarOpen(!isSidebarOpen);
  };
  const [notificationbar, setNotificationbar] = useState(false);
  const toggleNotification = () => {
    setNotificationbar(!notificationbar);
  };
  const [settingsBar, setSettingsBar] = useState(false);
  const toggleSettingsBar = () => {
    setSettingsBar(!settingsBar);
  };

  const [rate, setRate] = useState(1);
  const currencyCode = user?.currency;
  useEffect(() => {
    let isMounted = true;
    const fetchRate = async () => {
      const r = await getRate(currencyCode);
      if (isMounted) setRate(r);
    };
    fetchRate();
    return () => {
      isMounted = false;
    };
  }, [currencyCode]);


  return (
    <div className="container-fluid">
      <div className="row g-0">
        <Notification
          isOpen={notificationbar}
          toggleNotification={toggleNotification}
        />
        <Sidebar
          title="Components"
          isOpen={isSidebarOpen}
          toggleSidebar={toggleSidebar}
          toggleSettingsBar={toggleSettingsBar}
          settingsBar={settingsBar}
        />
        <div className="col ps-md-2 mainBar">
          <Header
            title="Components"
            icon={
              <FontAwesomeIcon icon={faWallet} style={{ fontSize: "16px" }} />
            }
            toggleSidebar={toggleSidebar}
            toggleNotification={toggleNotification}
            toggleSettingsBar={toggleSettingsBar}
          />
          <main>
            <div className="row">
                  <div className="col-md-12"> <PortfolioCard /></div>   
                  <div className="col-md-8"> <BitcoinMarketStats /></div>  
                  <div className="col-md-4"> <CoinsPortfolio /></div>  

                  <div className="col-md-12"> <StockDashboard /> </div>
                              
                  <div className="col-md-4"> 
                    <div className="row">
                    <TradeForm
                  trade={trade}
                  setTrade={setTrade}
                  type={type}
                  setType={setType}
                />

                    </div>
                
              </div>
             
              
            </div>
          </main>
        </div>
      </div>
    </div>
  );
}

export default Components;
